//Processing
import { uploadFile } from 'src/utils';

//Components
import { FieldRow, FieldLabel } from 'src/generic/component';
import { FileDetails, FileUploader } from 'src/generic/component/file';

//Interface & Typing
import { IAppForm } from 'src/types/org/common/appFormSchema';
import { Draft } from 'src/types/common';
import { IMaterial } from 'src/types';
import { IFieldErrors, ErrorManager } from 'src/types/validation';

interface SupportDocFieldProps {
  categoryId: string;
  userName: string;
  readOnly?: boolean;
  app?: Draft<IAppForm>;
  errors: IFieldErrors;
  onUpdate?: (app: Draft<IAppForm>) => void;
}

export const SupportDocFields = ({ userName, categoryId, errors, readOnly, app, onUpdate }: SupportDocFieldProps) => {
  const { getError, hasError } = ErrorManager(errors);
  const supportFiles: IMaterial[] = app?.supportFiles || [];

  const supportRemove = (fileName: string) => {
    const updated = [...supportFiles];
    for (let x = 0; x < updated.length; x++) {
      if (updated[x].fileName === fileName) {
        updated.splice(x, 1);
      }
    }
    return updated;
  };

  const supportAdd = (item: IMaterial) => {
    const updated = supportRemove(item.fileName);
    updated.push(item);
    return updated;
  };

  const changed = (updates: Draft<IAppForm>) => {
    if (onUpdate) onUpdate({ ...app, ...updates });
  };

  return (
    <>
      <FieldRow>
        <FieldLabel variant="body1">Please upload supporting documentation via the link below. Please be sure to add a description to complete the upload.<br/>Acceptable file formats are jpg, png and pdf with a max file size of 5MB. </FieldLabel>
        {hasError('supportFiles') && (
          <span style={{ marginBottom: '8px' }} className="cb-input-helper cb-validation-error">
            {getError('supportFiles')}
          </span>
        )}
      </FieldRow>
      <FieldRow>
        {app?.supportFiles?.map((item, i) => {
          return (
            <FieldRow key={`support-file-${i}`}>
              <FileDetails
              readOnly={readOnly}
                data={item}
                onRemove={(item) => {
                  changed({ supportFiles: supportRemove(item.fileName) });
                }}
              />
            </FieldRow>
          );
        })}
      </FieldRow>
      {!readOnly &&
        <>
          <div style={{ marginBottom: '10px', borderBottom: '1px solid #EEE' }}></div>
          <FieldRow>
            <FileUploader
              uploadButton="Add file"
              onUploadFile={async (file: File, description: string | undefined) => {
                const record = { recordCategoryType: 'di', categoryId: categoryId };
                const material: IMaterial = await uploadFile(userName, record, file, description, undefined, true);
                changed({ supportFiles: supportAdd(material) });
              }}
            />
          </FieldRow>
        </>
      }
    </>
  );
};
